/**
 * ICONFIELD TOKENS
 */
import { SEMANTIC, type SemanticTokens } from '../semantic.js';

export function createIconfieldTokens(s: SemanticTokens) {
  return {
    iconFg: s.text.secondary, // --iconfield-icon-fg: var(--text-secondary)
    icon: {
      size: s.iconSizes.lg, // --iconfield-icon-size
    },
  };
}
export const iconfieldTokens = createIconfieldTokens(SEMANTIC);
